// Get Rich the Boring Way -- shared constants.
//
// Update AMAZON_URL once the book listing is live; both the Dashboard card
// and the /book page read from here.
export const AMAZON_URL = 'https://a.co/d/0b1CGhqF';
export const BOOK_TITLE = 'Get Rich the Boring Way';
export const BOOK_AUTHOR = 'Bobby Malik';
export const BOOK_COVER = '/get-rich-the-boring-way.jpg';
export const BOOK_TAGLINE = 'The full system, written down. One boring habit at a time.';

// Instagram presence for marketing surfaces.
export const IG_HANDLE = '@wealthfinancialsystems';
export const IG_URL = 'https://instagram.com/wealthfinancialsystems';

// TikTok and LinkedIn — used on /links (QR-code hub for social bios + print).
export const TIKTOK_HANDLE = '@wealth.financial4';
export const TIKTOK_URL = 'https://tiktok.com/@wealth.financial4';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/bobby-malik';
